import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.ListConciergePage';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Página de Solicitação de Produtos e Serviços',
  },
  msgErrorModule: {
    id: `${ScopeName}.msgErrorModule`,
    defaultMessage: 'Não foi possível carregar o módulo federado',
  },
});

export default Scope;
